import { useMutation } from "@apollo/client";

import { SetUserIdentityMutation, SetUserIdentityMutationVariables } from "@ctypes";
import { SET_USER_IDENTITY, USER } from "@graphql";

export const useSetUserIdentity = (variables?: SetUserIdentityMutationVariables) => {
  return useMutation<SetUserIdentityMutation, SetUserIdentityMutationVariables>(SET_USER_IDENTITY, {
    variables,
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
